import { render, staticRenderFns } from "./DaftarPerintah.vue?vue&type=template&id=16776b2e&"
import script from "./DaftarPerintah.vue?vue&type=script&lang=js&"
export * from "./DaftarPerintah.vue?vue&type=script&lang=js&"
import style0 from "./DaftarPerintah.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports